function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import classnames from 'classnames';
import { capitalize } from 'swag-common/utils/strings';
import Image from 'swag-client-common/components/ui/image';
import Tooltip from 'swag-client-common/components/ui/tooltip';
import { TrashRoundedSvgIcon } from 'swag-client-common/components/svg/trash-rounded.svg';
import classes from './associated-product-icon.scss';
export class AssociatedProductIcon extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleRelatedProductClick", () => {
      const {
        item,
        onProductClick
      } = this.props;
      if (item.isShared) {
        return;
      }
      onProductClick(item);
    });
    _defineProperty(this, "handleRelatedProductRemoveClick", () => {
      const {
        item,
        onProductRemoveClick
      } = this.props;
      const {
        product,
        isShared
      } = item;
      onProductRemoveClick(product._id, isShared);
    });
    _defineProperty(this, "getTooltip", () => {
      const {
        item
      } = this.props;
      const {
        isShared,
        product
      } = item;
      if (isShared) {
        return 'This product is part of a box. Please edit it from your cart.';
      }
      return capitalize(product.name);
    });
  }
  render() {
    const {
      item
    } = this.props;
    const {
      product,
      currentVariantImageUrl,
      isShared
    } = item;
    return /*#__PURE__*/React.createElement("div", {
      "data-associated-id": product._id,
      "data-tooltip": this.getTooltip(),
      className: classnames(classes.item)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.inner
    }, /*#__PURE__*/React.createElement(Tooltip, {
      direction: "top",
      className: classes.tooltip,
      tooltipText: this.getTooltip()
    }), /*#__PURE__*/React.createElement(Image, {
      alt: product.name,
      src: currentVariantImageUrl,
      className: classes.image,
      wrapperClassName: classnames(classes.imageWrapper, {
        [classes.disabled]: isShared
      }),
      onClick: this.handleRelatedProductClick
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.removeIcon,
      onClick: this.handleRelatedProductRemoveClick,
      "data-button": "RemoveAssociated"
    }, /*#__PURE__*/React.createElement(TrashRoundedSvgIcon, null)));
  }
}